import { ReportFilter } from 'types';
import { useReportFilters } from '../../../../hooks';

export const useRespondedOnTimeFilters = (): ReportFilter[] => {
  const { consultationTypeIds, authorityIds, consultationCategoryIds, responseTypeIds } =
    useReportFilters();

  return [consultationTypeIds, authorityIds, consultationCategoryIds, responseTypeIds];
};
